import { createContext, useContext } from 'react';

export const LanguageContext = createContext();

export const SUPPORTED_LANGUAGES = {
  cs: { name: 'Čeština', flag: '🇨🇿', code: 'cs' },
  en: { name: 'English', flag: '🇬🇧', code: 'en' }
};

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
